import { GoogleOAuthProvider } from '@react-oauth/google';


import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleOAuthProvider clientId="1022188210979-t8tj2nn9tt6rhjpcpo05c9t05trjcd08.apps.googleusercontent.com"  
  locale="es">

      
      <App />
    </GoogleOAuthProvider>
  </StrictMode>,
)

